<svelte:options accessors/>
<script>
    import {validate_int} from '../../validators.js';
    import {createEventDispatcher} from 'svelte';
    import {network} from '../../stores.js';

    const dispatch = createEventDispatcher();

    const fetchData = (async () => {
        return await network.fetch_painting();
    })();
    
    let price;
    
    // расчёт стоимости
    const change = (async (e) => {
        let params = await fetchData;

        if (!e || !e.target.matches('[name="price"]')) {
            price = (+params.price).toFixed(2);
        }

        let result = {
            idTovar: params.idTovar,
            type: 'покраска',
            name: 'Покраска',
            subname: params.name,
            title: 'Покраска',
            price: {rozn: 0, opt: 0, sebest: 0},
            quantity: 1,
            materials: {},
        };

        result.price.rozn = result.price.opt = result.price.sebest = +price > 0 ? price : 0;
    
        dispatch('item', result);
    });
</script>

{#await fetchData}
    <div class="card-body">
        <div class="text-center">
            <p>Загрузка..</p>
        </div>
    </div>
{:then data}
    <div class="card-body" on:keyup={change} on:paste={change} on:change={change} on:mousemove|once={change}>
        <div class="row">
           <div class="col-12">
                <div class="form-group boxed">
                    <div class="form-group boxed">
                        {#if data}
                            <div class="input-wrapper">
                                <label class="form-label">Стоимость</label>
                                <input type="number" name="price" class="form-control" min="0" bind:value={price} use:validate_int={price}>
                            </div>
                        {/if}
                    </div>
                </div>
            </div>
        </div>
    </div>
{/await}
